// extracted by mini-css-extract-plugin
export default {"root":"HFI0cpN0gr_2yYQ3kQan","svgEffect":"aJtBpAoe2It7pNv9g450"};